var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14 10.28C7.97874 10.28 10.28 7.97874 10.28 5.14C10.28 2.30126 7.97874 0 5.14 0C2.30126 0 0 2.30126 0 5.14C0 7.97874 2.30126 10.28 5.14 10.28Z",
    fill: "#ED1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04674 2.86983L7.40208 3.22519C7.52472 3.34783 7.52472 3.54669 7.40208 3.66935L3.67175 7.39964C3.54911 7.5223 3.35025 7.52228 3.22759 7.39964L2.87225 7.04428C2.74961 6.92164 2.74961 6.72278 2.87225 6.60012L6.60257 2.86979C6.72522 2.74717 6.92408 2.74717 7.04674 2.86983Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40208 7.0443L7.04672 7.39966C6.92408 7.5223 6.72522 7.5223 6.60256 7.39966L2.87225 3.66933C2.74961 3.54669 2.74961 3.34783 2.87225 3.22517L3.22761 2.86981C3.35025 2.74717 3.54911 2.74717 3.67177 2.86981L7.40208 6.60014C7.52474 6.7228 7.52474 6.92166 7.40208 7.0443Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.efc850c290701f53413b112460b7781d.svg";
export { ForwardRef as ReactComponent };